import { cx } from 'emotion';
import { CSSProperties, MouseEventHandler, ReactNode } from 'react';

import { DeviceInfo } from '../../../utils/src';
import { clickable } from '../../helpers.css';
import RoundInfo from './RoundInfo/RoundInfo';
import Text from './Text';
import {
  gradientFooterClass,
  iosFullScreenFooter,
  mobileContainer,
  gameFooterContainer,
  leftClass,
  rightClass,
} from './style.css';

type GameFooterProps = {
  children?: ReactNode;
  className?: string;
  gradient?: boolean;
  style?: CSSProperties;
};

const Left = ({
  children,
  className,
}: {
  children?: ReactNode;
  className?: string;
}) => <div className={cx(leftClass, className)}>{children}</div>;

type RightProps = {
  isClickable: boolean;
  children?: ReactNode;
  onClick?: MouseEventHandler<HTMLDivElement>;
};

const Right = ({ isClickable, children, onClick }: RightProps) => (
  <div
    className={cx(rightClass, {
      [clickable]: isClickable,
    })}
    onClick={onClick}
  >
    {children}
  </div>
);

const GameFooter = ({
  className,
  children,
  gradient = false,
  style,
  ...props
}: GameFooterProps) => (
  <footer
    className={cx(
      gameFooterContainer,
      {
        [mobileContainer]: DeviceInfo.isHandheld,
        [iosFullScreenFooter]: DeviceInfo.isIOS,
        [gradientFooterClass]: gradient,
      },
      className
    )}
    style={style}
    {...props}
  >
    {children}
  </footer>
);

GameFooter.Text = Text;
GameFooter.Left = Left;
GameFooter.Right = Right;
GameFooter.RoundInfo = RoundInfo;

export { GameFooter, type GameFooterProps };
